import { AxiosError, AxiosResponse } from 'axios';
import {
    PERSON_CREATE_REQUESTED,
    PERSON_CREATE_SUCCEEDED,
    PERSON_UPDATE_REQUESTED,
    PERSON_CREATE_FAILED,
    PERSON_UPDATE_SUCCEEDED,
    PERSON_UPDATE_FAILED,
    PERSON_DELETE_REQUESTED,
    PERSON_DELETE_SUCCEEDED,
    PERSON_DELETE_FAILED,
    PERSON_GROUPED_PEOPLE_EXPORT_REQUESTED,
    PERSON_GROUPED_PEOPLE_EXPORT_SUCCEEDED,
    PERSON_GROUPED_PEOPLE_EXPORT_FAILED,
    PERSON_GROUPED_PEOPLE_IMPORT_REQUESTED,
    PERSON_GROUPED_PEOPLE_IMPORT_SUCCEEDED,
    PERSON_GROUPED_PEOPLE_IMPORT_FAILED
} from './constants';
import {
    Person,
    RequestedCreatePersonAction,
    SucceededCreatePersonAction,
    FailedCreatePersonAction,
    RequestedUpdatePersonAction,
    SucceededUpdatePersonAction,
    FailedUpdatePersonAction,
    RequestedDeletePersonAction,
    SucceededDeletePersonAction,
    FailedDeletePersonAction,
    RequestedExportGroupedPeopleAction,
    SucceededExportGroupedPeopleAction,
    FailedExportGroupedPeopleAction,
    RequestedImportGroupedPeopleAction,
    SucceededImportGroupedPeopleAction,
    FailedImportGroupedPeopleAction
} from './types';

export function createPerson(
    data: Partial<Person>
): RequestedCreatePersonAction {
    return {
        type: PERSON_CREATE_REQUESTED,
        data,
        meta: {
            logentries: true
        }
    };
}

export function personCreated(
    response: AxiosResponse
): SucceededCreatePersonAction {
    return {
        type: PERSON_CREATE_SUCCEEDED,
        response,
        payload: response,
        meta: {
            schemaName: 'person'
        }
    };
}

export function failedCreatePerson(
    error: AxiosError
): FailedCreatePersonAction {
    return {
        type: PERSON_CREATE_FAILED,
        payload: error,
        error: true
    };
}

export function editPerson(
    id: Person['id'],
    data: Partial<Person>
): RequestedUpdatePersonAction {
    return {
        type: PERSON_UPDATE_REQUESTED,
        id,
        data,
        meta: {
            logentries: true
        }
    };
}

export function personEdited(
    id: Person['id'],
    response: AxiosResponse
): SucceededUpdatePersonAction {
    return {
        type: PERSON_UPDATE_SUCCEEDED,
        id,
        response,
        payload: response,
        meta: {
            schemaName: 'person'
        }
    };
}

export function failedEditPerson(error: AxiosError): FailedUpdatePersonAction {
    return {
        type: PERSON_UPDATE_FAILED,
        payload: error,
        error: true
    };
}

export function deletePerson(id: Person['id']): RequestedDeletePersonAction {
    return {
        type: PERSON_DELETE_REQUESTED,
        id,
        meta: {
            logentries: true
        }
    };
}

export function personDeleted(
    id: Person['id'],
    response: AxiosResponse
): SucceededDeletePersonAction {
    return {
        type: PERSON_DELETE_SUCCEEDED,
        id,
        response
    };
}

export function failedDeletePerson(
    error: AxiosError
): FailedDeletePersonAction {
    return {
        type: PERSON_DELETE_FAILED,
        payload: error,
        error: true
    };
}

export function requestedExportGroupedPeople(
    peopleId: Person['id'][]
): RequestedExportGroupedPeopleAction {
    return {
        type: PERSON_GROUPED_PEOPLE_EXPORT_REQUESTED,
        payload: peopleId,
        meta: {
            logentries: true
        }
    };
}

export function succeededExportGroupedPeople(
    response: AxiosResponse
): SucceededExportGroupedPeopleAction {
    return {
        type: PERSON_GROUPED_PEOPLE_EXPORT_SUCCEEDED,
        payload: response,
        meta: {
            logentries: true
        }
    };
}

export function failedExportGroupedPeople(
    error: AxiosError
): FailedExportGroupedPeopleAction {
    return {
        type: PERSON_GROUPED_PEOPLE_EXPORT_FAILED,
        payload: error,
        error: true,
        meta: {
            logentries: true
        }
    };
}

export function requestedImportGroupedPeople(data: {
    file: File;
    organizationIds: string[];
}): RequestedImportGroupedPeopleAction {
    return {
        type: PERSON_GROUPED_PEOPLE_IMPORT_REQUESTED,
        payload: data,
        meta: {
            logentries: true
        }
    };
}

export function succeededImportGroupedPeople(
    response: AxiosResponse
): SucceededImportGroupedPeopleAction {
    return {
        type: PERSON_GROUPED_PEOPLE_IMPORT_SUCCEEDED,
        payload: response,
        meta: {
            logentries: true
        }
    };
}

export function failedImportGroupedPeople(
    error: AxiosError
): FailedImportGroupedPeopleAction {
    return {
        type: PERSON_GROUPED_PEOPLE_IMPORT_FAILED,
        payload: error,
        error: true,
        meta: {
            logentries: true
        }
    };
}
